import { supabase } from './supabase';

/**
 * Lists registered app users (from public.app_users) after server-side admin gate check.
 */
export async function fetchAppUsersForAdmin(adminEmail, adminPassword) {
  const { data, error } = await supabase.rpc('admin_list_app_users', {
    p_admin_email: adminEmail,
    p_admin_password: adminPassword,
  });

  if (error) {
    throw new Error(error.message || 'Request failed');
  }

  if (!data || data.success !== true) {
    throw new Error(data?.error || 'Could not load users');
  }

  const raw = data.users;
  if (Array.isArray(raw)) return raw;
  return [];
}
